import { FreeServicesRequestListGridComponent } from './free-services-request-list-grid.component';
import { FreeServicesRequestSearchFormModel } from '../free-services-request-search-form/free-services-request-search-form.model';
import {
  ColumnSetting,
  ColumnType,
  GenericGridToolbarItemName,
  GenericToolbarItemName,
  GridToolBarItem,
} from '../../gk-kendo';
import {
  iwIconAnuluj,
  iwIconColorDlk,
  iwIconColorSz,
  iwIconPlus,
} from '../../assets/css/ewid-svg/svg-icons';
import { AnyGeometryObject } from '../../gk-map/models';

export const getFreeServicesRequestListGridToolbarItems = (
  c: FreeServicesRequestListGridComponent,
): GridToolBarItem[] => {
  return [
    {
      name: 'searchRequests',
      svgIcon: iwIconPlus,
      className: 'svg-icon-blue',
      title: 'FREE_PORTAL_SERVICES.SEARCH',
      text: 'FREE_PORTAL_SERVICES.SEARCH',
      showText: 'overflow',
      callback: () => c.openSearchRequestWindow(),
    },
    {
      name: GenericGridToolbarItemName.RemoveGridItem,
      className: 'svg-icon-blue',
    },
    {
      name: GenericGridToolbarItemName.RemoveAllGridItems,
      className: 'svg-icon-blue',
    },
    {
      name: GenericToolbarItemName.GetPointGeometryFromMap,
      title: 'FREE_PORTAL_SERVICES.POINT_CASE',
      payload: () => ({
        doneCallback: (anyGeometryObject: AnyGeometryObject[]): void => {
          c.freeServicesRequestListGridDataService
            .queryByState({
              filter: FreeServicesRequestSearchFormModel.fromAppToApi(
                c.fspRequestSearchFormModel,
                !c.displayRequestArchive,
                anyGeometryObject[0].geom,
              ),
            })
            .subscribe();
        },
      }),
    },
    {
      name: 'parcelForRequest',
      svgIcon: iwIconColorDlk,
      title: 'FREE_PORTAL_SERVICES.PARCELS',
      text: 'FREE_PORTAL_SERVICES.PARCELS',
      showText: 'overflow',
      callback: () => c.openParcelsForRequestListWindow(),
    },
    {
      name: 'requestDetails',
      svgIcon: iwIconColorSz,
      title: 'FREE_PORTAL_SERVICES.DETAILS',
      text: 'FREE_PORTAL_SERVICES.DETAILS',
      showText: 'overflow',
      callback: () => c.showDetailsWindow(),
    },
    {
      name: 'cancelRequest',
      svgIcon: iwIconAnuluj,
      className: 'svg-icon-red',
      title: 'FREE_PORTAL_SERVICES.CANCEL',
      text: 'FREE_PORTAL_SERVICES.CANCEL',
      showText: 'overflow',
      disabled: () => c.isDisableCancelRequest,
      callback: () => c.handleCancelRequest(),
    },
    {
      spacer: true,
      name: 'archival',
      title: 'FREE_PORTAL_SERVICES.ARCHIVAL_LABEL',
      text: 'FREE_PORTAL_SERVICES.ARCHIVAL',
      toggleable: true,
      selected: () => c.displayRequestArchive,
      callback: (event) => c.onDisplayRequestArchiveChange(event as Event),
    },
  ];
};

export const freeServicesRequestListGridColumns: ColumnSetting[] = [
  {
    field: 'Numer',
    title: 'Nr kancelaryjny',
    type: ColumnType.Text,
  },
  {
    field: 'DataRozpocz',
    title: 'Data rozpoczęcia',
    type: ColumnType.Date,
    width: 140,
  },
  {
    field: 'Status',
    title: 'Status',
    type: ColumnType.Text,
  },
  {
    field: 'DataZalatw',
    title: 'Data załatwienia',
    type: ColumnType.Date,
    width: 140,
  },
  {
    field: 'Dokumenty',
    title: 'Dokumenty z ODGiK',
    type: ColumnType.Boolean,
  },
];
